import { CheckCircle } from 'lucide-react'

import { useApproveCampaignColumn } from 'services/campaignColumns/hooks'

interface Props {
  campaignId: number
  columnId: number
}

export function ApproveButton({ campaignId, columnId }: Props) {
  const approve = useApproveCampaignColumn(campaignId)
  return (
    <button
      type="button"
      onClick={() => approve.mutate(columnId)}
      disabled={approve.isPending}
      className="ml-2 inline-flex items-center gap-1 rounded-md bg-brand px-2 py-0.5 text-xxs uppercase text-fg-inverse hover:bg-brand-hover disabled:opacity-50"
    >
      <CheckCircle className="h-3 w-3" />
      {approve.isPending ? 'Approving…' : 'Approve'}
    </button>
  )
}
